  (function (clientId) {
    if (window["__adal_disable_" + clientId]) { return; }

    var script = document.currentScript;
    var pageType = script ? script.getAttribute("data-page-type") : "";

    var adalyserLoaded = false;
    function loadAdalyser() {
      if (adalyserLoaded) { return; }
      adalyserLoaded = true;
      (function (windowAlias, documentAlias, trackerName) {
        if (!windowAlias[trackerName]) {
          windowAlias.GlobalAdalyserNamespace = windowAlias.GlobalAdalyserNamespace || [];
          windowAlias.GlobalAdalyserNamespace.push(trackerName);
          windowAlias[trackerName] = function () {
            (windowAlias[trackerName].q = windowAlias[trackerName].q || []).push(arguments);
          };
          windowAlias[trackerName].q = windowAlias[trackerName].q || [];
          var nel = documentAlias.createElement("script"),
            fel = documentAlias.getElementsByTagName("script")[0];
          nel.async = 1;
          nel.src = "https://c0.adalyser.com/adalyser.js?cid=" + clientId;
          fel.parentNode.insertBefore(nel, fel);
        }
      }(window, document, "adalyserTracker"));
      window.adalyserTracker("create", {
        campaignCookieTimeout: 15552000,
        conversionCookieTimeout: 604800,
        clientId: clientId,
        trafficSourceInternalReferrers: ["^(.*\\.)?onedaytest.*$"]
      });
      window.adalyserTracker("trackSession", "lce1");
      if (pageType === "page") {
        window.adalyserTracker("trackEvent", "lce2", {}, true);
      } else if (pageType === "product") {
        window.adalyserTracker("trackEvent", "lce3", {}, true);
      }
    }

    // Case 1: visitor accepts cookies on this page load (banner interaction)
    document.addEventListener("visitorConsentCollected", function (event) {
        if (event.detail && event.detail.marketingAllowed) { loadAdalyser(); }
    });

    
    // Case 2: visitor already accepted on a previous page/visit
    function checkExistingConsent() {
      if (!(window.Shopify && typeof window.Shopify.loadFeatures === "function")) { return; }
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          if (error) { return; }
          if (window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.marketingAllowed()) {
            loadAdalyser();
          } 
        } 
      );
    } 
    
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      checkExistingConsent();
    } else {
      document.addEventListener("DOMContentLoaded", checkExistingConsent);
    } 
  })("onedaytest");